import { connect } from 'react-redux';

import {
  getReviewsTotal,
  getHasReviewsSection,
  getReviews,
  getIsShowMoreReviews,
  getHotelReviewsLink,
} from 'src/store/reviews/selectors';

import { getIsWhitelabel } from 'src/store/view/selectors';
import ReviewsMobile from './ReviewsMobile';

const mapStateToProps = (state) => ({
  hasReviewsSection: getHasReviewsSection(state),
  totalReviews: getReviewsTotal(state),
  items: getReviews(state),
  isShowMoreVisible: getIsShowMoreReviews(state),
  isWhitelabel: getIsWhitelabel(state),
  hotelReviewsLink: getHotelReviewsLink(state),
});

export default connect(mapStateToProps)(ReviewsMobile);
